<template>
	<b-col align-self="center">
		<b-link
			v-if="assetLink.fileName && direction == 'down'"
			href="#"
			:alt="assetLink.fileName"
			title="Download file"
			@click.prevent="downloadFile(assetLink)"
		>
			<b-icon font-scale="1.5" :icon="getIcon(assetLink.fileName)"></b-icon>
		</b-link>

		<b-link
			v-if="direction == 'up'"
			title="Upload file"
			@click.prevent="chooseFile"
		>
			<b-icon icon="box-arrow-up"></b-icon>
		</b-link>

		<input
			:accept="accept"
			type="file"
			ref="files"
			v-show="false"
			@change.prevent="uploadFile"
		/>
		<confirm v-if="direction == 'up'" ref="confirm"></confirm>
	</b-col>
</template>

<script>
import FileService from "@/api-services/file.service";
import Confirm from "@/components/partials/confirm";
import { dateFuncs } from "@/globs.js";
import Vue from "vue";
import * as path from "path";

const assetType = {
	0: { heading: "Documents", accept: ".pdf, .txt, .doc, .docx, .xls, .xlsx" },
	1: { heading: "Images", accept: "image/*" },
	2: { heading: "Videos", accept: "video/*" },
};

export default {
	name: "FileAsset",

	components: { Confirm },

	// things we have inherited from our parent
	props: ["asset", "relate", "type", "folder", "direction"],

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function () {
		return {
			assetLink: {},
			file: [],

			fullscreen: false,

			extensionsList: [
				{ value: "file-post", extension: ".pdf" },
				{ value: "file-text", extension: ".txt" },
				{ value: "file-richtext", extension: [".docx", ".doc"] },
				{ value: "file-spreadsheet", extension: [".xlsx", ".xls"] },
			],
		};
	},

	computed: {
		heading: function () {
			return assetType[this.type].heading;
		},

		accept: function () {
			return assetType[this.type].accept;
		},
	},

created() {
		// if we get here and already have an array, then don't wait for a watch that may never come.
		if (this.asset) {
			var unwatch = this.$watch('asset');
			unwatch();
			this.fetchExistingAsset();
		}
		
	},

	// things we do to data
	methods: {
		chooseFile() {
			this.$refs.files.click();
		},

		getIcon(filename) {
			let ext = path.extname(filename);

			let icon =
				this.extensionsList.find((item) => {
					let { extension } = item;
					if (Array.isArray(extension)) {
						return extension.includes(ext);
					} else if (typeof extension === "string") {
						return extension === ext;
					}
				}) || {};

			return icon.value || "file-text";
		},

		// GET AND ENCODE ASSET
		fetchExistingAsset() {
			if (this.asset) {
				let assetType = this.assetType;

				switch (this.type) {
					case "0": // if it's a document we can use a placeholder and stream response in download link
						this.getDocument(this.asset);
						break;
				}
			}
		},

		getDocument(_asset) {
			this.assetLink = {
				guid: _asset.NanId,
				fileName: _asset.FileName,
				contentType: _asset.ContentType,
				added: dateFuncs.backEndDateFormat(_asset.Added),
			};
		},

		downloadFile(_asset) {
			FileService.get(_asset.guid)
				.then((response) => {
					const url = window.URL.createObjectURL(
						new Blob([response.data])
					);

					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", _asset.fileName);
					document.body.appendChild(link);
					link.click();
				})
				.catch((error) => {
					this.handleError(error);
				});
		},

		/*
           UPLOAD NEW FILES
        */
		submitFile() {
			//Initialize the form data
			let formData = new FormData();

			// Iterate over any file sent over appending the files to the form data.
			for (var i = 0; i < this.files.length; i++) {
				let file = this.files[i];
				formData.append("files[" + i + "]", file);
			}

			// add the type of file form prop
			formData.append("AssetType", this.type);
			formData.append("Folder", this.folder);

			// probably need to delete the original file.
			let guid = this.assetLink.guid;

			if (guid !== undefined) {
				FileService.delete(this.folder, guid).then(() => {
					this.uploadToApi(formData);
				});
			} else {
				this.uploadToApi(formData);
			}
		},

		uploadToApi(_formData) {
			// Make the request to the POST /multiple-files handler in api service
			FileService.upload(this.relate, _formData)
				.then((res) => {
					res.data.forEach((asset, i) => {
						switch (this.type) {
							case "0": // if it's a document we can use a placeholder and stream response in download link
								this.getDocument(asset);
								break;
						}
					});

					this.$refs.confirm.open(
						"Success",
						"File(s) uploaded",
						true
					);
				})

				.then(() => {
					this.$refs.files.value = "";
				});
		},

		uploadFile() {
			this.files = this.$refs.files.files;
			this.submitFile();
		},

		handleError(err) {
			let modal_options = {
				text: "light",
				background: "danger",
			};
			let message;

			if (err.response.data != '') {

				message = err.MessageDetail != null ? err.MessageDetail : err.ExceptionMessage;

			} else {

				switch (err.response.status) {
					case 404:
						message = err.response.status + ' - Could not find requested data';
						break;
					case 500:
						message = err.response.status + ' - There was a fatal error whilst processing this request';
						break;

					default:
						message = err.response.status + ' - There was an unknown error whilst processing this request';
				}
			}

			this.$refs.confirm.open('Error', message, true, modal_options);
		},
	},

	watch: {
		// Watch for the assets prop to be populated from ajax
		asset: function () {
			this.fetchExistingAsset();
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/partials/document-asset.vue